/* eslint-disable import/prefer-default-export */
export const moduleConstants = {
  GETALL_REQUEST: 'MODULES_GETALL_REQUEST',
  GETALL_SUCCESS: 'MODULES_GETALL_SUCCESS',
  GETALL_SUCCESS_BOTH_LEVELS: 'MODULES_GETALL_SUCCESS_BOTH_LEVELS',
  GETALL_FAILURE: 'MODULES_GETALL_FAILURE',

  GET_PROGRESS_REQUEST: 'MODULES_GET_PROGRESS_REQUEST',
  GET_PROGRESS_SUCCESS: 'MODULES_GET_PROGRESS_SUCCESS',
  GET_PROGRESS_FAILURE: 'MODULES_GET_PROGRESS_FAILURE',

  GETALL_RESULTS_SUCCESS: 'MODULES_GETALL_RESULTS_SUCCESS',

  UNLOAD_MODULES: 'MODULES_UNLOAD_MODULES',
};
